const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Credentials/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Credentials/Search')

export default [
  {
    path: 'credentials/create',
    name: 'CredentialsCreate',
    component: Single,
    meta: {
      title: 'Adicionar Credencial',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'credentials',
        action: 'create'
      }
    }
  },
  {
    path: 'credentials/:id',
    name: 'CredentialsEdit',
    component: Single,
    meta: {
      title: 'Editar Credencial',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'credentials',
        action: 'read'
      }
    }
  },
  {
    path: 'credentials',
    name: 'CredentialsSearch',
    component: Search,
    meta: {
      title: 'Credenciais',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'credentials',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/credentials.js